<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-row>
         <b-col lg="2" style="padding-left: 22px;">
            <a> {{$t('WORKFLOW.DOCUMENT_TYPE')}} <span style="color: red;">*</span>
              <b-button v-if="!isRotatedDoc" class="btn btn-primary btn-sm" variant="secondary" v-b-tooltip.hover.viewport style="margin-left: 5px;border-radius: 6px; margin-bottom: 5px"  @mouseover="showTooltip = true"  @mouseout="showTooltip = false">
                <i class="fa fa-info-circle"></i>
              </b-button>
               <div v-if="showTooltip" class="custom-tooltip">
                <img src="../../../static/img/templateimg.png">
                <h5>
                  <p>Step 1 - Determine the document category that matches the Start form/HIPAA consent version.</p>
                  <p>Step 2 - Select the thumbnail image representing this particular document.</p>
                  <p>Step 3 - Next, scroll down to the bottom of the page to find and make a note of the Map ID linked to this form.</p>
                  <p>Step 4 - Following that, check the checkbox adjacent to SF/HIPAA and confirm that the document category matches the MAP ID of SF/HIPAA.</p>
                </h5>
               </div>
            </a>  
            <b-form-select :plain="true" :options="setFormTypeOptions" :disabled="isRotatedDoc" placeholder="Select Document Type" v-model="formType" v-on:change="disableCheckboxOnEditedDoc"></b-form-select>
          </b-col>
          <div v-if="loading" class="loading-overlay">
            <div class="loading-spinner"></div>
          </div>
          <!-- <b-col lg="2" style="padding-top: 11px;">
            <a>Enter File Name (Optional)</a>
            <b-form-input v-model="text" placeholder="Enter File Name"
            :class="{'is-invalid': $v.text.$error}"
            @input="$v.text.$touch()">
            </b-form-input>
            <b-form-invalid-feedback v-if="!$v.text.maxLength">File Name length should be less than 15 characters</b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!$v.text.valid">File Name can't accept symbols</b-form-invalid-feedback>
          </b-col> -->
          <b-col lg="5" style="margin-top: 27px;">
            <b-button v-if="!isRotatedDoc" style="margin-bottom: 5px;padding-bottom: 0px;border-radius: 6px;height: 40px;margin-top: 0px;margin-right: 5px" size="sm" class = "addGroupBtn" variant="secondary" :disabled="disableSaveButton || this.editAttachmentsEnabled !== null" v-on:click="CheckboxSave"><span> <h5>Save</h5> </span></b-button>
            <b-button v-if="!isRotatedDoc" style="margin-bottom: 5px;padding-bottom: 0px;border-radius: 6px; height: 40px;margin-top: 0px;margin-right: 5px" size="sm" class = "addGroupBtn" variant="secondary" v-on:click="clearEditedAttachedPages(); CheckboxClear();"><span> <h5>Reset</h5> </span></b-button>
            <b-button v-if="!isRotatedDoc" style="margin-bottom: 5px;padding-bottom: 0px;border-radius: 6px; height: 40px;margin-top: 0px;margin-right: 5px"  size="sm" class = "addGroupBtn" variant="secondary" :disabled="processButtonDisabled || this.editAttachmentsEnabled !== null || Object.keys(selectedTitleDocs).length<=0 || isEditedDoc" v-on:click="doProcess">
              <span> <h5>Process <i v-if="processButtonDisabled" class="fa fa-spinner fa-spin mr-2" style="font-size:16px"></i><span></span></h5> </span>
            </b-button>
            <b-button v-if="isRotatedDoc" style="margin-bottom: 5px;padding-bottom: 0px;border-radius: 6px; height: 40px;margin-top: 0px;margin-right: 5px"  size="sm" class = "addGroupBtn" variant="secondary" v-on:click="exportRotatedDoc">
              <span> <h5>Export <i v-if="processButtonDisabled" class="fa fa-spinner fa-spin mr-2" style="font-size:16px"></i><span></span></h5> </span>
            </b-button>
            <b-button style="margin-bottom: 5px;padding-bottom: 0px;border-radius: 6px; height: 40px;margin-top: 0px;margin-right: 5px"  size="sm" class = "addGroupBtn" variant="secondary" v-on:click="showRejectFormModal">
              <span> <h5>Reject <i style="font-size:16px"></i><span></span></h5> </span>
            </b-button>
            <b-button style="margin-bottom: 5px;padding-bottom: 0px;border-radius: 6px; height: 40px;margin-top: 0px;margin-right: 5px"  size="sm" class = "addGroupBtn" variant="secondary" v-on:click="rotateSelectedImgs(-90)">
              <span> <h5>Rotate Left<i style="font-size:16px"></i><span></span></h5> </span>
            </b-button>
            <b-button style="margin-bottom: 5px;padding-bottom: 0px;border-radius: 6px; height: 40px;margin-top: 0px;margin-right: 5px"  size="sm" class = "addGroupBtn" variant="secondary" v-on:click="rotateSelectedImgs(+90)">
              <span> <h5>Rotate Right<i style="font-size:16px"></i><span></span></h5> </span>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div style="text-align:center">
      <b-row>
        <b-col lg="3">
        </b-col>
      </b-row>
    </div>
    <b-row style="padding: 10px">
      <b-col sm="6">
        <b-card sm="6" style="overflow-y: scroll; height: 60vh;" >
          <div v-if="isRotatedDoc" class="notes-margin">
            <ul>
              <h5 style="font-weight: bold;">Note:</h5>
              <li>Kindly choose an image and adjust its orientation as needed.</li>
              <li>After rotating the pages, hit Export to see the whole document with the changes in Salesforce.</li>
            </ul>
          </div>
          <div v-else>
            <b-col lg="6">
              <h5>Triaged Documents</h5>
            </b-col>
            <b-col lg="6">

            </b-col>
            <b-col lg="12">
              <table class="result" style="width: 100%;">
                <tr class="result" style="background-color: rgb(168 174 179); font-size: 12px">
                  <!-- <th class="result"> File Name </th> -->
                  <th v-if="!isRotatedDoc" class="result"> Document Type </th>
                  <th class="result"> Page Number(s) </th>
                  <th v-if="!isRotatedDoc" class="result"> Attached<br> Page Number(s) </th>
                  <!-- <th v-if="!isRotatedDoc" class="result"> Insurance Card<br> Page Number(s) </th> -->
                  <th class="result"> Action </th>
                </tr>
                <tr :class="getResultCss(value)" v-for="(value,key) in selectedTitleDocs" style="font-size: 12px;" >
                  <!-- <td class="result" style="min-width: 60px;">{{value.title}}</td> -->
                  <td v-if="!isRotatedDoc" class="result">{{value.template_doc.text}}</td>   
                  <td class="result">{{value.pages.join(', ')}}</td>
                  <td v-if="!isRotatedDoc" class="result">
                    {{value.attachment_pages && value.attachment_pages.join(', ')}}
                    <br v-if="value.attachment_pages && value.attachment_pages.join(', ')">
                    <b-button v-if="value.attachment_pages && value.attachment_pages.length > 0" @click="removeAttachments(value, key)" style="border-radius: 5px; padding: 0px 3px 0px 3px" variant="secondary" v-b-tooltip.hover.viewport title="Remove Attachments">
                      <i class="fa fa-trash"></i>
                    </b-button>
                    <b-button v-if="value.attachment_pages && value.attachment_pages.length > 0" :disabled="isSecondEditButtonDisabled(key)" @click="editAttachments(value, key)" style="border-radius: 5px; padding: 0px 3px 0px 3px" variant="secondary" v-b-tooltip.hover.viewport title="Edit Attachments">
                      <i class="fa fa-edit"></i>
                    </b-button>
                    <b-button v-if="!['cover_page', 'attachments'].includes(value.formType)" :disabled="(selectedTitleDocs !== null && (editAttachmentsEnabled !== key && editAttachmentsEnabled !== null)) || isSecondEditButtonDisabled(key)" @click="addAttachments(value, key)" style="border-radius: 5px; padding: 0px 3px 0px 3px" variant="secondary" v-b-tooltip.hover.viewport title="Add Attachments">
                      <i class="fa fa-floppy-o"></i>
                    </b-button>
                  </td>
                  <!-- <td v-if="!isRotatedDoc" class="result">
                    {{ value.insurance_pages && value.insurance_pages.join(', ') }}
                    <br v-if="value.insurance_pages && value.insurance_pages.join(', ')">
                    <b-button v-if="value.insurance_pages && value.insurance_pages.length > 0" @click="removeInsPages(value, key)" style="border-radius: 5px; padding: 0px 3px 0px 3px" variant="secondary" v-b-tooltip.hover.viewport title="Remove Insurance Card Page">
                      <i class="fa fa-trash"></i>
                    </b-button>
                    <b-button v-if="value.insurance_pages && value.insurance_pages.length > 0" :disabled="isSecondEditButtonDisabled(key)" @click="editInsPages(value, key)" style="border-radius: 5px; padding: 0px 3px 0px 3px" variant="secondary" v-b-tooltip.hover.viewport title="Edit Insurance Card Page">
                      <i class="fa fa-edit"></i>
                    </b-button>
                    <b-button v-if="!['cover_page', 'attachments'].includes(value.formType)" :disabled="selectedTitleDocs !== null && (editInsCardsEnabled !== key && editInsCardsEnabled !== null) || isSecondEditButtonDisabled(key)" @click="addInsPages(value, key)" style="border-radius: 5px; padding: 0px 3px 0px 3px" variant="secondary" v-b-tooltip.hover.viewport title="Save/Add Insurance Card">
                      <i class="fa fa-floppy-o"></i>
                    </b-button>
                  </td> -->
                  <td class="result">
                    <b-button :disabled="(selectedTitleDocs !== null && editAttachmentsEnabled !== null) || (selectedTitleDocs !== null && editInsCardsEnabled !== null)" @click="editPages(value, key)" style="border-radius: 5px; padding: 0px 6px 0px 6px" variant="primary" v-b-tooltip.hover.viewport title="Edit" >
                      <i class="fa fa-edit"></i>
                    </b-button>
                    <b-button @click="removePages(value, key)" style="border-radius: 5px; padding: 0px 6px 0px 6px" variant="danger" v-b-tooltip.hover.viewport title="Remove" >
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </td>
                </tr>
              </table>
            </b-col>
          </div>
        </b-card>
        <!-- <b-col v-else sm="3" style="overflow: scroll; max-height: 60vh;">
          <b-card header="All images">
            <div style="margin-top: 10px" v-for="page in allPages">
              <b-card :title="page.title">
              <img onContextMenu="return false;" width="250" height="350" :src="page? axios.defaults.baseURL.replace('/api', '') + page.image_url: ''" class="card-img"  :id="page.original_title + page.id">
              </b-card>
            </div>
          </b-card>
        </b-col> -->
      </b-col>
      <b-col sm="6" style="overflow: scroll; max-height: 120vh;" class="scrollable-content">
        <Container
          orientation="horizontal"
          @drop="onColumnDrop($event)"
          drag-handle-selector=".column-drag-handle"
          @drag-start="dragStart"
          :drop-placeholder="upperDropPlaceholderOptions"
          >
          <Draggable v-for="column in scene.children" :key="column.id">
            <b-card>
              <div :class="column.props.className">
                <div class="card-column-header d-flex justify-content-between" style="padding:10px 0.5px; background-color: #a8aeb3;">
                  <div class="checkbox-padding">
                    <input type="checkbox" style="transform: scale(1.1);" :id="column.id" v-if="column.name === 'Unmatched Pages'" v-model="selectAllUnmatched" ref="selectAllUnmatchedClicks" v-on:change="selectAllUnmatchedPages()">
                      <!-- <label v-if="column.name === 'Unmatched Pages'" :for="column.name" style="font-weight: normal;">Select All</label> -->
                    <input type="checkbox" style="transform: scale(1.1);" :id="column.id" v-if="column.name === 'Templates'" v-model="selectAllTemplates" ref="selectAllTemplateClicks" v-on:change="selectAllTemplatePages()">
                      <!-- <label v-if="column.name === 'Templates'" :for="column.name" style="font-weight: normal;">Select All</label> -->
                  </div>
                  <div>
                    <span class="column-drag-handle"></span>
                    {{ column.name === 'Templates' ? 'Enrollment Forms' : column.name }}
                  </div>
                  <div style="width: 30px;"></div>
                </div>
                <Container
                  style = "width: 23.5vw; height: 900px; background-color: #ebeff3"
                  group-name="col"
                  @drop="(e) => onCardDrop(column.id, e)"
                  @drag-start="(e) => log('drag start', e)"
                  @drag-end="(e) => log('drag end', e)"
                  :get-child-payload="getCardPayload(column.id)"
                  drag-class="card-ghost"
                  drop-class="card-ghost-drop"
                  :drop-placeholder="dropPlaceholderOptions"
                  >
                  <Draggable   style="padding:1px; " v-for="card in column.children" :key="card.id">
                    <div v-if="isEditedDoc ? (card.data.form && card.data.form.isEdited === true) :(card.data.form && card.data.form.process!== true)">
                      <div v-if= "card.data.found && card.data.form "  :class="card.props.className" v-bind:style="card.data.form.process == true ? 'border: 2px solid green' : 'border: none;'">
                        <div class="d-flex justify-content-between">
                          <div class="checkbox-padding">
                            <input type="checkbox" v-if="!card.data.form.isEdited" :id="card.id" ref="CheckboxClicks" v-on:change="updateDisableCheckBox()" />
                            <input type="checkbox" v-else :value="card.data.form.id"  :id="card.id" ref="CheckboxClicks" v-on:change="updateDisableCheckBox()" v-model="editedCheckedBoxes" />
                          </div>
                          <p>Page: {{card.data.form.original_page_no}}</p>    
                        </div>
                        <img @load = "loadingImage($event, card.data.form)" onContextMenu="return false;" v-on:click="viewFullImage(card.data.form, column.name)" width="100" height="300" :src="card.data.form ? axios.defaults.baseURL.replace('/api', '') + card.data.form.image_thumbnail: ''" class="card-img"  :id="card.data.form.id + card.data.form.original_title" :style="{ transform: `rotate(${card.data.form.rotation}deg)` }">
                      </div>
                      <div v-else>
                        <img onContextMenu="return false;" width="100" height="300" class="card-img">
                      </div>
                    </div>
                    <div v-else>
                      <img onContextMenu="return false;" width="100" height="239" class="card-img">
                    </div>
                  </Draggable>
                </Container>
              </div>
            </b-card>
          </Draggable>
        </Container>
      </b-col>
    </b-row>

    <b-modal class="modal-primary" size="lg" centered id = "hideModal" ref="viewFullImage" no-close-on-esc hide-header-close no-close-on-backdrop scrollable >
      <div slot="modal-header">
        <label >{{ selectedImage.title }}</label>
        <b-button size="sm" variant="dark" style="padding: 4px 8px;border-radius:0px" @click="imageRotateLeft()" v-b-tooltip.hover.viewport :title="$t('FORMS.ROTATE_LEFT')"><i class="fa fa-undo"></i></b-button>
        <b-button size="sm" variant="dark" style="padding: 4px 8px;border-radius:0px" @click="imageRotateRight()" v-b-tooltip.hover.viewport :title="$t('FORMS.ROTATE_RIGHT')"><i class="fa fa-repeat"></i></b-button>
      </div>
      <b-row>
        <b-col :sm="12">
          <div style="height: 75vh; overflow-y:auto">
            <img style = "width: 80%" onContextMenu="return false;" @load = "loadingImage($event,selectedImage)" v-if="modelOpen" :src="selectedImage ? axios.defaults.baseURL.replace('/api', '') + selectedImage.image_url: ''" class="card-img" :id="selectedImage.id" :style="{ transform: `rotate(${this.angle}deg)` }">
          </div>
        </b-col>
        <!-- <b-col sm="2" v-if="selectedColumn === 'Templates'">
          <b-row>
            <b-form-group :label="$t('FORMS.FORCED_TEMPLATE')" label-for="basicText" >
              <b-form-select :plain="true"
                             :options="templateOptions"
                             v-model="forced_template_doc_id"
                             @input="handleTemplateSelect()"
                             :placeholder="$t('FORMS.TEMPLATE')"></b-form-select>
            </b-form-group>
          </b-row>
          <b-row>
            <zoom-center-transition>
              <img :src="previewImageUrl" class="shadow preview-image">
            </zoom-center-transition>
        </b-row>
        </b-col> -->
      </b-row>
      <div slot="modal-footer">
          <b-btn size="sm" variant="secondary" @click="saveRotationTemplateImage()"> Save </b-btn>
          <b-btn size="sm" variant="light" @click="closeRotationTemplateImage()"> {{ $t('COMMON.CLOSE') }} </b-btn>
      </div>
    </b-modal>

    <b-modal hide-header-close  title="Reject Form" header-bg-variant="light" ref="rejectFormDoc" centered>
        <b-card class="mt-3">
          <b-row class="form-group">
            <b-col cols="12">
              <img src="../../../static/img/exclamation.png">
              <h5>Do you want to reject this document?</h5>
            </b-col>
          </b-row>
        </b-card>
        <div slot="modal-footer">
          <b-btn size="sm" variant="danger" @click="rejectForm"> Confirm </b-btn>
          <b-btn size="sm" variant="light" @click="hideRejectFormDocModal"> {{ $t('COMMON.CANCEL') }} </b-btn>
        </div>
      </b-modal>

    <b-modal hide-header-close  title="Alert" header-bg-variant="light" ref="unmatchedPagesAlert" centered>
      <b-card class="mt-3">
        <b-row class="form-group">
          <b-col cols="12">
            <h5>The form cannot be processed from the unmatched pages panel, so please drag the image from the Unmatched Pages and drop it into the Enrollment Forms Panel. Then, select the appropriate checkbox and save.</h5>
          </b-col>
        </b-row>
      </b-card>
      <div slot="modal-footer">
        <b-btn size="sm" variant="dark" @click="$refs.unmatchedPagesAlert.hide()"> Ok </b-btn>
      </div>
    </b-modal>

    <b-modal hide-header-close  title="Alert" header-bg-variant="light" ref="rotatePagesAlert" centered>
      <b-card class="mt-3">
        <b-row class="form-group">
          <b-col cols="12">
            <h5>Kindly choose at least one form to rotate.</h5>
          </b-col>
        </b-row>
      </b-card>
      <div slot="modal-footer">
        <b-btn size="sm" variant="dark" @click="$refs.rotatePagesAlert.hide()"> Ok </b-btn>
      </div>
    </b-modal>

    <b-modal hide-header-close  title="Alert" header-bg-variant="light" ref="multipleInsAlert" centered>
      <b-card class="mt-3">
        <b-row class="form-group">
          <b-col cols="12">
            <h5>Please note that only one insurance card can be processed with the start form. Kindly verify your selection and choose the correct insurance card.</h5>
          </b-col>
        </b-row>
      </b-card>
      <div slot="modal-footer">
        <b-btn size="sm" variant="dark" @click="$refs.multipleInsAlert.hide()"> Ok </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { Container, Draggable } from 'vue-smooth-dnd'
import { applyDrag, generateItems } from './helpers'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import { maxLength } from 'vuelidate/lib/validators'
import { uuid } from 'vue-uuid'
import router from '../../router'

const columnNames = ['Unmatched Pages', 'Templates']
const cardColors = [
  'azure',
  'beige',
  'bisque',
  'blanchedalmond',
  'burlywood',
  'cornsilk',
  'gainsboro',
  'ghostwhite',
  'ivory',
  'khaki'
]
const pickColor = () => {
  const rand = Math.floor(Math.random() * 10)
  return cardColors[rand]
}
const scene = {
  type: 'container',
  props: {
    orientation: 'horizontal'
  },
  children: generateItems(columnNames.length, i => ({
    id: `column${i}`,
    type: 'container',
    name: columnNames[i],
    props: {
      orientation: 'vertical',
      className: 'card-container'
    },
    children: generateItems(2, j => ({
      type: 'draggable',
      id: `${i}${j}`,
      props: {
        className: 'card',
        style: {backgroundColor: pickColor()}
      },
      data: 'yes'
    }))
  }))
}
export default {
  name: 'Cards',
  components: {Container, Draggable, Multiselect, uuid},
  data () {
    return {
      loading: false,
      scene,
      showTooltip: false,
      upperDropPlaceholderOptions: {
        className: 'cards-drop-preview',
        animationDuration: '150',
        showOnTop: true
      },
      dropPlaceholderOptions: {
        className: 'drop-preview',
        animationDuration: '150',
        showOnTop: true
      },
      matchedPages: [],
      nonMatchedPages: [],
      dLCards: [],
      icCards: [],
      allPages: [],
      angle: 0,
      rotateAllAngle: 0,
      modelOpen: false,
      rotationSave: false,
      selectedImage: {},
      selectedColumn: '',
      templateOptions: [],
      formType: null,
      selectedTitleDocs: {},
      isFirstEditButtonClicked: false,
      previewImageUrl: '',
      forced_template_doc_id: '',
      processButtonDisabled: false,
      CheckboxClicks: '',
      text: '',
      vaildFormsData: false,
      traigeStatus: {
        NEW: 1,
        INPROGRESS: 2,
        PARTIALLY_COMPLETED: 3,
        COMPLETED: 4,
        REJECTED: 5,
        RECALLED: 6,
        TRIAGED: 12
      },
      // productList: [],
      selectedProduct: [],
      groupDocs: {
        'Templates': [],
        'Insurance': [],
        'Driving': []
      },
      inBoundDocumentCaseId: '',
      showResult: true,
      editAttachmentsEnabled: null,
      editInsCardsEnabled: null,
      isEditedDocKey: null,
      isEditedDoc: false,
      disableSaveButton: true,
      columnCount: 1,
      editedCheckedBoxes: [],
      formDocTitle: '',
      isRotatedDoc: false,
      formDoc: null,
      selectAllUnmatched: false,
      selectAllTemplates: false,
      rotationAngle: 0
    }
  },
  beforeDestroy () {
    this.scene.children.map(column => {
      if (column.type === 'container') {
        column.children.map(element => {
          if (element.data.form && this.editAttachmentsEnabled && this.selectedTitleDocs[this.editAttachmentsEnabled].attachment_formIds.includes(element.data.form.id)) {
            element.data.form.process = true
            element.data.form.isAttachment = true
          }
          if (element.data.form && this.editInsCardsEnabled && this.selectedTitleDocs[this.editInsCardsEnabled].insurance_ids.includes(element.data.form.id)) {
            element.data.form.process = true
            element.data.form.isInsurance = true
          }
        })
      }
    })
    this.editAttachmentsEnabled = null
    this.editInsCardsEnabled = null
  },
  computed: {
    ...mapGetters([ 'idToken', 'userRole', 'userRoleOrder', 'selectedRolesData', 'appMode' ]),
    setFormTypeOptions () {
      let matchOptions = [
        { value: null, text: 'Select Document Type' }
      ]
      matchOptions.push(...this.templateOptions)
      return matchOptions
    },
    isSecondEditButtonDisabled () {
      return (key) => {
        return this.selectedTitleDocs !== null && (
          (this.editAttachmentsEnabled !== key && this.editAttachmentsEnabled !== null) || this.isFirstEditButtonClicked
        )
      }
    }
  },
  mounted () {
    this.updateSavebutton()
  },
  created () {
    this.$refs.CheckboxClicks = []
    Vue.axios.get('/form_docs/' + this.$route.params.id, { headers: { Authorization: `Bearer ${this.idToken}` } })
      .then(res => {
        this.isRotatedDoc = res.data.form_doc.is_rotated
        this.formDoc = res.data.form_doc
        if (res.data.form_doc.forms_doc_status === 1) {
          this.setDocumentStatus(this.traigeStatus['INPROGRESS'])
        }
        this.inBoundDocumentCaseId = res.data.form_doc.inbound_doc_case_id
        let pages = res.data.forms.map(eachFormData => {
          let newForm = eachFormData.form
          newForm.image_thumbnail = eachFormData.image_thumbnail
          newForm.image_url = eachFormData.image_path
          newForm.original_title = eachFormData.form.title
          newForm.angle = eachFormData.form.rotation_angle
          newForm.process = false
          newForm.isEdited = false
          newForm.isAttachment = false
          newForm.isInsurance = false
          newForm.rotation = eachFormData.form.rotation_angle
          return newForm
        })
        let keys = Object.keys(res.data.form_doc.saved_triage_docs)
        this.selectedTitleDocs = res.data.form_doc.saved_triage_docs
        let sceneColumns = {}
        for (const key of keys) {
          let value = this.selectedTitleDocs[key]
          if (sceneColumns[value.sceneColumn] === undefined) {
            sceneColumns[value.sceneColumn] = []
          }
          let validFormIds = value.formIDs.filter(formId => {
            return !value.attachment_formIds.includes(formId) && !value.insurance_ids.includes(formId)
          })
          sceneColumns[value.sceneColumn].push(...validFormIds)
        }
        this.productList = res.data.product_list
        this.formDocTitle = res.data.form_doc.title
        // this.productList = res.data.product_list
        this.allPages = pages
        console.log('allPages = ', pages)
        this.matchedPages = pages.filter(form => (sceneColumns.column1 && sceneColumns.column1.includes(form.id)) || (form.closest_template_id > 0 && form.template_diff !== null && parseInt(form.template_diff) <= 3))
        // this.matchedPages = pages.filter(form => (sceneColumns.column1 && sceneColumns.column1.includes(form.id)) || (form.closest_template_id === null && form.template_diff == null))
        this.matchedPages.forEach(function (element) {
          var index = pages.indexOf(element)
          pages.splice(index, 1)
        })
        console.log('matchedPages = ', this.matchedPages)
        this.dLCards = pages.filter(form => (sceneColumns.column3 && sceneColumns.column3.includes(form.id)) || form.closest_template_id === -5)
        this.dLCards.forEach(function (element) {
          var index = pages.indexOf(element)
          pages.splice(index, 1)
        })
        console.log('dLCards = ', this.dLCards)
        this.icCards = pages.filter(form => (sceneColumns.column2 && sceneColumns.column2.includes(form.id)) || form.closest_template_id === -2)
        this.icCards.forEach(function (element) {
          var index = pages.indexOf(element)
          pages.splice(index, 1)
        })
        console.log('icCards = ', this.icCards)
        this.nonMatchedPages = pages.filter(form => (form.closest_template_id === null || form.template_diff === '200.0' || (form.template_diff && parseInt(form.template_diff) >= 3)))
        this.nonMatchedPages.map(formPage => {
          formPage.closest_template_id = null
          return formPage
        })
        console.log('nonMatchedPages = ', this.nonMatchedPages)
        let newScean = {
          type: 'container',
          props: {
            orientation: 'horizontal'
          },
          children: generateItems(columnNames.length, i => ({
            id: `column${i}`,
            type: 'container',
            name: columnNames[i],
            props: {
              orientation: 'vertical',
              className: 'card-container'
            },
            children: generateItems(res.data.forms.length, j => {
              if (i === 1) {
                return ({
                  type: 'draggable',
                  id: `${i}${j}`,
                  props: {
                    className: 'card',
                    style: {backgroundColor: pickColor()}
                  },
                  data: {name: 'template', found: true, form: this.matchedPages[j]}
                })
              } else if (i === 2) {
                return ({
                  type: 'draggable',
                  id: `${i}${j}`,
                  props: {
                    className: 'card',
                    style: {backgroundColor: pickColor()}
                  },
                  data: {name: 'ic cards', found: true, form: this.icCards[j]}
                })
              } else if (i === 3) {
                return ({
                  type: 'draggable',
                  id: `${i}${j}`,
                  props: {
                    className: 'card',
                    style: {backgroundColor: pickColor()}
                  },
                  data: {name: 'dLCards', found: true, form: this.dLCards[j]}
                })
              } else {
                return ({
                  type: 'draggable',
                  id: `${i}${j}`,
                  props: {
                    className: 'card',
                    style: {backgroundColor: pickColor()}
                  },
                  data: {name: 'others', found: true, form: this.nonMatchedPages[j]}
                })
              }
            })
          }))
        }
        this.scene = newScean
        this.setSavedTriageDocs()
        this.validAllForms()
        this.sortDraggablesForms()
        Vue.axios.get('/template_docs/list_options', { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(response => {
            this.templateOptions = response.data.template_docs
            // let templates = this.matchedPages
            // this.matchedPages = templates.map(page => {
            //   let templateDoc = this.templateOptions.filter(templateDoc => templateDoc.templates.includes(page.closest_template_id))
            //   page.template_doc_id = templateDoc.length > 0 ? templateDoc[0].value : '-1'
            //   return page
            // })
          }, error => {
            if (error.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else if (error.status === 500) {
              Vue.toasted.show(this.$t('COMMON.MSG_PROCESS_FAIL'), { icon: 'chain-broken', type: 'error' })
            }
          })
      })
      .catch(err => console.log(err))
  },
  validations: {
    text: {
      maxLength: maxLength(15),
      valid: function (value) {
        const regexExp = /^[a-zA-Z0-9 _-]*$/.test(value)
        return regexExp
      }
    }
  },
  methods: {
    toggleSelectAll (columnName, columnIds, selectAllClicks, selectAllColumn) {
      this.scene.children.map(column => {
        if (column.type === 'container' && column.name === columnName) {
          column.children.map(element => {
            if (element.data.form) {
              columnIds.push(element.id)
            }
          })
        }
      })
      selectAllClicks.map(element => {
        if (element.checked && columnIds.length > 0) {
          selectAllColumn = true
          this.disableSaveButton = false
        } else if (element.checked === false || columnIds.length === 0) {
          selectAllColumn = false
          this.disableSaveButton = true
          this.formType = null
        }
      })
      if (selectAllColumn) {
        let checkedIdArray = []
        this.$refs.CheckboxClicks.map(element => {
          if (columnIds.includes(element.id)) {
            element.checked = true
            checkedIdArray.push(element.id)
          }
        })
        if (columnName === 'Templates') {
          this.documentAutoMatching(checkedIdArray)
        } else {
          this.disableSaveButton = true
          this.formType = null
        }
      } else if (selectAllColumn === false) {
        this.$refs.CheckboxClicks.map(element => {
          if (columnIds.includes(element.id)) {
            element.checked = false
          }
        })
        this.disableSaveButton = true
      }
    },
    selectAllUnmatchedPages () {
      let columnIds = []
      this.toggleSelectAll('Unmatched Pages', columnIds, this.$refs.selectAllUnmatchedClicks, this.selectAllUnmatched)
    },
    selectAllTemplatePages () {
      let columnIds = []
      this.toggleSelectAll('Templates', columnIds, this.$refs.selectAllTemplateClicks, this.selectAllTemplates)
    },
    documentAutoMatching (checkedIdArray) {
      const templatesContainer = this.scene.children.find((child) => child.type === 'container' && child.name === 'Templates')
      if (!templatesContainer) return null
      const matchingChild = templatesContainer.children.find((child) => checkedIdArray[0] === child.id && child.data.form.closest_template_id)
      if (!matchingChild) return null
      const closestTemplateId = matchingChild.data.form.closest_template_id
      const matchingTemplate = this.templateOptions.find((templateDoc) => templateDoc.templates.includes(closestTemplateId))
      if (matchingTemplate && checkedIdArray.length === matchingTemplate.templates.length) {
        this.disableSaveButton = false
        this.formType = matchingTemplate.value
      } else {
        this.disableSaveButton = false
        this.formType = null
      }
    },
    exportRotatedDoc () {
      this.$store.commit('setRotatedDocFormDocId', this.formDoc.id)
      router.push({path: `/process/processed`})
    },
    setSavedTriageDocs () {
      let keys = Object.keys(this.selectedTitleDocs)
      this.columnCount = keys.length === 0 ? 1 : Number(keys[keys.length - 1]) + 1
      this.scene.children.map(column => {
        if (column.type === 'container') {
          column.children.map(element => {
            for (const key of keys) {
              if (element.data.form && this.selectedTitleDocs[key].formIDs.includes(element.data.form.id)) {
                if (this.selectedTitleDocs[key].attachment_formIds.includes(element.data.form.id)) {
                  element.data.form.isAttachment = true
                }
                if (this.selectedTitleDocs[key].insurance_ids.includes(element.data.form.id)) {
                  element.data.form.isInsurance = true
                }
                if (this.selectedTitleDocs[key].formType === 'cover_page') {
                  element.data.form.process = true
                  element.data.coverPage = true
                  element.data.form.title = this.selectedTitleDocs[key].title
                  this.disableCoverPageCheckBox = true
                  this.coverPageSelected = true
                } else if (this.selectedTitleDocs[key].formType === 'attachments') {
                  element.data.form.process = true
                  element.data.form.title = this.selectedTitleDocs[key].title
                  element.data.form.patient_id = this.selectedTitleDocs[key].patient_id
                  element.data.form.case_no = this.selectedTitleDocs[key].case_no
                  element.data.form.record_type = this.selectedTitleDocs[key].record_type
                  element.data.form.tags = this.selectedTitleDocs[key].tags
                } else {
                  element.data.form.process = true
                  element.data.form.title = this.selectedTitleDocs[key].title
                }
                this.selectedTitleDocs[key].forms.map(form => {
                  if (element.data.form.id === form.id) {
                    element.data.form.product = form.product
                    element.data.form.tags = form.tags
                    element.data.form.template_doc_id = form.template_doc_id
                    element.data.form.closest_template_id = form.closest_template_id
                  }
                })
                element.data.form.uuid = this.selectedTitleDocs[key].uuid
              }
            }
          })
        }
      })
    },
    updateSavebutton () {
      let checkedIdArray = []
      this.$refs.CheckboxClicks.map(element => {
        if (element.checked === true) {
          checkedIdArray.push(element.id)
        }
      })
      if (this.$v.text.$error === true || checkedIdArray.length === 0) {
        this.disableSaveButton = true
      } else if (this.isRotatedDoc && checkedIdArray.length > 0) {
        this.disableSaveButton = false
      } else {
        this.disableSaveButton = false
      }
    },
    sortDraggablesForms () {
      this.scene.children.map(column => {
        if (column.type === 'container') {
          column.children.sort((a, b) => {
            if ((a.data.form && a.data.form.process === false) && (b.data.form && b.data.form.process === false)) {
              return column.children.indexOf(a) - column.children.indexOf(b)
            }
            if (a.data.form && a.data.form.process === false) {
              return -1
            }
            if (a.data.form && a.data.form.process === true) {
              return 1
            }
            return 0
          })
        }
      })
    },
    checkUnmatchedPages: function (checkedIdArray) {
      let containerIndex = this.scene.children.findIndex(item => item.type === 'container' && item.id === 'column0')
      let container = this.scene.children[containerIndex]
      if (container) {
        let hasMatchingChild = container.children.some(child => checkedIdArray.includes(child.id))
        if (hasMatchingChild) {
          return false
        }
      }
      return true
    },
    CheckboxSave: function () {
      this.isSaveButtonClicked = true
      this.isFirstEditButtonClicked = false
      let checkedIdArray = []
      this.$refs.CheckboxClicks.map(element => {
        if (element.checked === true) {
          checkedIdArray.push(element.id)
        }
      })
      if (checkedIdArray.length > 0) {
        if ((!this.checkUnmatchedPages(checkedIdArray)) && !this.isRotatedDoc) {
          this.$refs.unmatchedPagesAlert.show()
          return
        } else if (this.formType) {
          let documentType = this.templateOptions.find(templateDoc => templateDoc.value === this.formType)
          if (documentType && (documentType.templates.length !== checkedIdArray.length)) {
            this.isFirstEditButtonClicked = true
            return Vue.toasted.show('The selected document type has more or fewer pages than the selected forms.', {type: 'error', duration: 5000})
          }
        } else if (!this.isRotatedDoc && this.formType === null) {
          return Vue.toasted.show('Document type is required', {type: 'error'})
        }
        let title = this.text.trim().replace(/ /g, '_')
        let isValidTemplates = true
        let docDetails = {}
        let uniqueId = uuid.v1()
        docDetails['title'] = title
        docDetails['forms'] = []
        docDetails['pages'] = []
        docDetails['formIDs'] = []
        docDetails['template_doc'] = []
        docDetails['attachment_pages'] = []
        docDetails['attachment_formIds'] = []
        docDetails['force_template_id'] = []
        docDetails['sceneColumn'] = []
        docDetails['tags'] = []
        docDetails['insurance_ids'] = []
        docDetails['insurance_pages'] = []
        console.log('docDetails = ', docDetails)
        this.scene.children.map(column => {
          if (column.type === 'container') {
            this.extractFormTypeData(column.name, column.children)
            column.children.map(element => {
              if (checkedIdArray.indexOf(element.id) >= 0) {
                if (this.formType) {
                  docDetails['forms'].push(element.data.form)
                  docDetails['formIDs'].push(element.data.form.id)
                  // docDetails['product'] = this.formType !== 'attachments' ? (this.isVerified ? this.selectedProduct : 'Pharmacy') : this.selectedProduct
                  docDetails['formType'] = this.formType
                  docDetails['column'] = {text: column.name, value: column.name === 'Insurance cards' ? '-2' : '0'}
                  docDetails['pages'].push(element.data.form.original_page_no)
                  docDetails['force_template_id'] = this.formType
                  docDetails['sceneColumn'] = column.id
                  docDetails['template_doc'] = this.templateOptions.filter(template => {
                    return template.value === this.formType
                  })
                  if (!this.isEditedDoc) {
                    docDetails['uuid'] = uniqueId
                  }
                  if (column.name === 'Templates' && docDetails['template_doc'].length < 1 && this.formType !== 'attachments') {
                    isValidTemplates = false
                  } else {
                    element.data.form.title = title
                    element.data.form.process = true
                    element.data.form.isEdited = false
                    // element.data.form.product = this.formType !== 'attachments' ? (this.isVerified ? this.selectedProduct : 'Pharmacy') : this.selectedProduct
                    element.data.form.template_doc_id = this.formType
                    element.data.form.uuid = uniqueId
                  }
                }
              }
            })
          }
        })
        if (isValidTemplates) {
          if (this.isEditedDoc) {
            let attachementsFormIds = this.selectedTitleDocs[this.isEditedDocKey]['attachment_formIds']
            docDetails['formIDs'].push(...attachementsFormIds)
            docDetails['attachment_formIds'] = this.selectedTitleDocs[this.isEditedDocKey]['attachment_formIds']
            docDetails['attachment_pages'] = this.selectedTitleDocs[this.isEditedDocKey]['attachment_pages']
            this.selectedTitleDocs[this.isEditedDocKey] = {}
            this.selectedTitleDocs[this.isEditedDocKey] = docDetails
            this.selectedTitleDocs[this.isEditedDocKey]['template_doc'] = docDetails['column'] && docDetails['column'].text !== 'Insurance cards'
              ? (this.formType === 'cover_page' ? {text: 'Cover Page', value: true} : this.formType === 'attachments' ? {text: 'Attachments', value: true} : docDetails['template_doc'][0]) : docDetails['column']
          } else {
            this.selectedTitleDocs[this.columnCount] = {}
            this.selectedTitleDocs[this.columnCount] = docDetails
            this.selectedTitleDocs[this.columnCount]['template_doc'] = docDetails['column'] && docDetails['column'].text !== 'Insurance cards'
              ? (this.formType === 'cover_page' ? {text: 'Cover Page', value: true} : this.formType === 'attachments' ? {text: 'Attachments', value: true} : docDetails['template_doc'][0]) : docDetails['column']
            this.columnCount = this.columnCount + 1
          }
        } else {
          this.scene.children.map(column => {
            if (column.type === 'container') {
              this.extractFormTypeData(column.name, column.children)
              column.children.map(element => {
                if (checkedIdArray.indexOf(element.id) >= 0 && element.data.form) {
                  element.data.form.process = false
                  element.data.form.isEdited = false
                }
              })
            }
          })
        }
        if (this.isEditedDoc && isValidTemplates) {
          let remainingFormIDs = this.selectedTitleDocs[this.isEditedDocKey]['formIDs'].filter((formID) => !this.selectedTitleDocs[this.isEditedDocKey]['formIDs'].includes(formID))
          this.scene.children.map(column => {
            if (column.type === 'container') {
              this.extractFormTypeData(column.name, column.children)
              column.children.map(element => {
                if (element.data.form && docDetails['attachment_formIds'].includes(element.data.form.id)) {
                  element.data.form.title = title
                }
                if (element.data.form && remainingFormIDs.includes(element.data.form.id)) {
                  element.data.form.process = false
                  element.data.form.isEdited = false
                }
              })
            }
          })
          // if (this.selectedEditTitle !== this.isEditedDocKey) {
          //   delete this.selectedTitleDocs[this.selectedEditTitle]
          // }
        }
        this.scene.children.map(column => {
          if (column.type === 'container') {
            this.extractFormTypeData(column.name, column.children)
            column.children.map(element => {
              if (checkedIdArray.indexOf(element.id) >= 0) {
                if (this.text !== '') {
                  element.data.form.title = this.text
                  element.data.form.process = true
                  element.data.form.product = this.selectedProduct
                }
              }
            })
          }
        })
        this.validAllForms()
        this.CheckboxClear()
        this.saveSelectedDocs()
      }
    },
    CheckboxClear: function () {
      this.$refs.CheckboxClicks.map(element => {
        element.checked = false
      })
      if (!(this.editAttachmentsEnabled || this.editInsCardsEnabled)) {
        this.editedCheckedBoxes = []
      }
      this.text = ''
      this.selectedProduct = []
      this.formType = null
      if (this.isEdited) {
        this.selectedTitleDocs[this.isEditedDocKey]['isEdited'] = false
      }
      this.isSaveButtonClicked = true
      this.isFirstEditButtonClicked = false
      this.isEditedDoc = false
      this.disableSaveButton = true
      this.selectAllUnmatched = false
      this.selectAllTemplates = false
      this.sortDraggablesForms()
    },
    handleTemplateSelect: function () {
      let templateDoc = this.templateOptions.filter(templateDoc => templateDoc.value === this.forced_template_doc_id)
      this.previewImageUrl = this.axios.defaults.baseURL.replace('/api', '') + templateDoc[0].image_url
    },
    loadingImage (e, data) {
      // this.angle = data.angle
      // var img = e.target
      // img.style.transform = 'rotate(' + this.angle + 'deg)'
    },
    rotateSelectedImgs (angle) {
      let checkedIdArray = []
      let checkedFormIds = []
      let origPageNos = []
      this.$refs.CheckboxClicks.map(element => {
        if (element.checked === true) {
          checkedIdArray.push(element.id)
        }
      })
      this.scene.children.map(column => {
        if (column.type === 'container') {
          column.children.map(ele => {
            if (ele.data.form && checkedIdArray.includes(ele.id)) {
              checkedFormIds.push(ele.data.form.id)
              origPageNos.push(ele.data.form.original_page_no)
            }
          })
        }
      })
      if (checkedIdArray.length > 0) {
        this.loading = true
        this.rotateAllAngle = angle
        Vue.axios.post('form_docs/rotate_all_images', { ids: checkedFormIds, rotation_angle: this.rotateAllAngle, original_page_nos: origPageNos, form_doc_id: `${this.$route.params.id}` }, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            if (res.data.error) {
              Vue.toasted.show(this.$t('FORMS.IMAGE_ROTATE_FAIL'), { icon: 'chain-broken', type: 'error' })
            } else {
              Vue.toasted.show(this.$t('FORMS.IMAGE_ROTATE_SUCCESS'), { type: 'success' })
            }
            let imageData = res.data.image_data
            this.scene.children.map(column => {
              if (column.type === 'container') {
                column.children.map(element => {
                  if (element.data.form) {
                    imageData.map(data => {
                      if (data.form_id === element.data.form.id) {
                        element.data.form.rotation = data.rotation_angle
                        element.data.form.angle = data.rotation_angle
                        element.data.form.rotation_angle = data.rotation_angle
                      }
                    })
                  }
                })
              }
            })
            this.rotateAllAngle = 0
            this.CheckboxClear()
          })
          .catch(err => {
            Vue.toasted.show(this.$t('FORMS.IMAGE_ROTATE_FAIL'), { icon: 'chain-broken', type: 'error' })
            console.log(err)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$refs.rotatePagesAlert.show()
      }
    },
    imageRotateLeft: function () {
      var img = document.getElementById(this.selectedImage.id)
      this.angle = this.angle - 90
      this.rotationSave = true
      img.style.transform = 'rotate(' + this.angle + 'deg)'
    },
    imageRotateRight: function () {
      var img = document.getElementById(this.selectedImage.id)
      this.angle = this.angle + 90
      this.rotationSave = true
      img.style.transform = 'rotate(' + this.angle + 'deg)'
    },
    closeRotationTemplateImage () {
      this.angle = 0
      this.modelOpen = false
      this.rotationSave = false
      this.$refs['viewFullImage'].hide()
    },
    saveRotationTemplateImage () {
      if (this.rotationSave) {
        let previousAngle = this.angle - this.selectedImage.rotation_angle
        Vue.axios.post('form_docs/rotate_image', { id: this.selectedImage.id, rotation_angle: previousAngle, original_page_no: [this.selectedImage.original_page_no] }, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(response => {
            Vue.toasted.show(this.$t('FORMS.IMAGE_ROTATE_SUCCESS'), { type: response.data.error ? 'error' : 'success' })
            this.scene.children.map(column => {
              if (column.type === 'container') {
                column.children.map(element => {
                  if (element.data.form && element.data.form.id === this.selectedImage.id) {
                    console.log('element = ', element, this.selectedImage.id)
                    element.data.form.angle = response.data.rotation_angle
                    element.data.form.rotation = response.data.rotation_angle
                    element.data.form.rotation_angle = response.data.rotation_angle
                  }
                })
              }
            })
            this.angle = 0
            this.modelOpen = false
            this.rotationSave = false
          })
          .catch(err => {
            Vue.toasted.show(this.$t('FORMS.IMAGE_ROTATE_FAIL'), { icon: 'chain-broken', type: 'error' })
            console.log(err)
          })
      }
      this.$refs['viewFullImage'].hide()
    },
    onColumnDrop (dropResult) {
      const scene = Object.assign({}, this.scene)
      scene.children = applyDrag(scene.children, dropResult)
      this.scene = scene
    },
    onCardDrop (columnId, dropResult) {
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        const scene = Object.assign({}, this.scene)
        const column = scene.children.filter(p => p.id === columnId)[0]
        const columnIndex = scene.children.indexOf(column)
        const newColumn = Object.assign({}, column)
        newColumn.children = applyDrag(newColumn.children, dropResult)
        scene.children.splice(columnIndex, 1, newColumn)
        this.scene = scene
        this.disableSelectAllOnCardDrop(this.scene)
      }
      if (dropResult.addedIndex !== null && this.isEditedDoc === false) {
        this.sortDraggablesForms()
      }
    },
    disableSelectAllOnCardDrop (scene) {
      let templateContainer = scene.children.filter(column => column.name === 'Templates')
      let unmatchedContainer = scene.children.filter(column => column.name === 'Unmatched Pages')
      let isTemplateFormsPresent = templateContainer[0].children.filter(item => item.data.form)
      let isUnmatchedFormsPresent = unmatchedContainer[0].children.filter(item => item.data.form)
      if (isTemplateFormsPresent.length === 0) {
        this.selectAllTemplates = false
      }
      if (isUnmatchedFormsPresent.length === 0) {
        this.selectAllUnmatched = false
      }
    },
    getCardPayload (columnId) {
      return index => {
        return this.scene.children.filter(p => p.id === columnId)[0].children[index]
      }
    },
    dragStart () {
    },
    log (...params) {
      console.log(...params)
    },
    viewFullImage (data, column) {
      this.selectedImage = data
      this.selectedColumn = column
      this.forced_template_doc_id = data.template_doc_id
      let templateDoc = this.templateOptions.filter(templateDoc => templateDoc.templates.includes(data.closest_template_id))
      this.previewImageUrl = templateDoc.length > 0 ? this.axios.defaults.baseURL.replace('/api', '') + templateDoc[0].image_url : ''
      data.templateDoc = templateDoc.length > 0 ? templateDoc[0] : {}
      this.modelOpen = true
      this.angle = data.angle
      this.$refs['viewFullImage'].show()
    },
    showModal () {
      this.$refs['viewFullImage'].show()
    },
    hideModal () {
      this.$refs['viewFullImage'].hide()
    },
    extractFormTypeData (column, data) {
      data = data.filter(image => image.data.found && image.data.form && image.data.form.template_doc_id !== 'attachments' && !image.data.coverPage && !image.data.form.isAttachment)
      data = data.map(data => data.data)
      return data
    },
    doProcess () {
      let res = {}
      let attachedPages = {}
      let insurancePages = {}
      this.processButtonDisabled = true
      this.scene.children.map(column => {
        if (column.type === 'container') {
          column.children.map(element => {
            if (element.data.form && element.data.form.isAttachment === true) {
              if (attachedPages[element.data.form.uuid] === undefined) {
                attachedPages[element.data.form.uuid] = []
              }
              attachedPages[element.data.form.uuid].push(element.data.form.id)
            }
            if (element.data.form && element.data.form.isInsurance === true) {
              if (insurancePages[element.data.form.uuid] === undefined) {
                insurancePages[element.data.form.uuid] = []
              }
              insurancePages[element.data.form.uuid].push(element.data.form.id)
            }
          })
          res[column.name.replace(/ /g, '_')] = this.extractFormTypeData(column.name, column.children)
        }
      })
      res['Attachments'] = attachedPages
      res['insurance_cards'] = insurancePages
      res.Templates.forEach(template => {
        template.form.title = this.formDocTitle
      })
      Vue.axios.post('form_docs/process_docs', {res, triage_doc_id: this.$route.params.id, inbound_doc_case_id: this.inBoundDocumentCaseId}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.processButtonDisabled = false
          if (res.data.status) {
            this.$router.push('/process/processed?status=processing')
          } else {
            Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(err => {
          this.processButtonDisabled = false
          console.log(err)
        })
    },
    saveSelectedDocs () {
      // 2 - INPROGRESS, 3 - Partially Completed
      let statusID = null
      if (this.vaildFormsData) {
        statusID = this.traigeStatus['TRIAGED']
      } else if (Object.keys(this.selectedTitleDocs).length > 0) {
        statusID = this.traigeStatus['PARTIALLY_COMPLETED']
      } else {
        statusID = this.traigeStatus['INPROGRESS']
      }
      Vue.axios.post('form_docs/save_triage_docs', {selected_docs: this.selectedTitleDocs, triage_doc_id: this.$route.params.id, status_id: statusID}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.validAllForms()
        })
        .catch(err => {
          console.log(err)
        })
    },
    rejectForm () {
      let res = {
        formDocId: `${this.$route.params.id}`
      }
      Vue.axios.post('form_docs/reject_form_docs', res, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.hideRejectFormDocModal()
          this.$router.push('/process/processed')
          Vue.toasted.show(`Form will remain in the system for ${res.data.retention_time} hours`, { icon: 'chain-broken', type: 'success' })
        })
        .catch(err => {
          console.log(err)
          Vue.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' })
        })
    },
    setDocumentStatus (status) {
      Vue.axios.post('form_docs/set_traige_document_status', {triage_doc_id: this.$route.params.id, status}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
        })
        .catch(err => {
          console.log(err)
        })
    },
    showRejectFormModal () {
      this.$refs.rejectFormDoc.show()
    },
    hideRejectFormDocModal () {
      this.$refs.rejectFormDoc.hide()
    },
    disableCheckboxOnEditedDoc () {
      this.isEditedDoc && this.updateDisableCheckBox()
    },
    updateDisableCheckBox () {
      if (this.selectedProduct === null && (!['attachments', 'cover_page'].includes(this.formType))) {
        this.disableSaveButton = true
      } else {
        let checkedIdArray = []
        this.$refs.CheckboxClicks.map(element => {
          if (element.checked === true) {
            checkedIdArray.push(element.id)
          }
        })
        if (checkedIdArray.length > 0) {
          this.disableSaveButton = false
        } else if (this.$v.text.$error === true || checkedIdArray.length === 0 || this.formType === null || (this.formType === 'attachments' && this.patientId === null && !this.hcoCaseNo && !this.physcianCaseNo)) {
          this.disableSaveButton = true
        } else {
          this.disableSaveButton = true
        }
      }
      let unmatchedColumnIds = []
      let templateColumnIds = []
      this.scene.children.map(column => {
        if (column.type === 'container' && column.name === 'Unmatched Pages') {
          column.children.map(element => {
            if (element.data.form) {
              unmatchedColumnIds.push(element.id)
            }
          })
        } else if (column.type === 'container' && column.name === 'Templates') {
          column.children.map(element => {
            if (element.data.form) {
              templateColumnIds.push(element.id)
            }
          })
        }
      })
      let checkedIdArray = []
      this.$refs.CheckboxClicks.map(element => {
        if (element.checked === true) {
          checkedIdArray.push(element.id)
        }
      })
      if (checkedIdArray.length === 0) {
        this.selectAllUnmatched = false
        this.selectAllTemplates = false
      } else {
        let selectedUnmatchedIds = unmatchedColumnIds.filter(element => checkedIdArray.includes(element))
        let selectedTemplateIds = templateColumnIds.filter(element => checkedIdArray.includes(element))
        if (unmatchedColumnIds.length === selectedUnmatchedIds.length) {
          this.selectAllUnmatched = true
        } else {
          this.selectAllUnmatched = false
        }
        if (templateColumnIds.length === selectedTemplateIds.length) {
          this.selectAllTemplates = true
        } else {
          this.selectAllTemplates = false
        }
      }
      if (templateColumnIds.length === 0) {
        this.selectAllTemplates = false
      }
      if (unmatchedColumnIds.length === 0) {
        this.selectAllUnmatched = false
      }
      let inRemPages = 0
      let i = 0
      for (i = 0; i < this.scene.children.length; i++) {
        if (this.scene.children[i].type === 'container' && this.scene.children[i].name === 'Unmatched Pages') {
          let j = 0
          for (j = 0; j < this.scene.children[i].children.length; j++) {
            if (checkedIdArray.indexOf(this.scene.children[i].children[j].id) >= 0) {
              inRemPages += 1
              this.formType = this.isRotatedDoc ? 'rotatedDoc' : null
            }
          }
          break
        }
      }
      if (inRemPages !== checkedIdArray.length) {
        this.disableCoverPageCheckBox = true
        // this.disableAttchments = checkedIdArray.length !== 1
      } else {
        this.disableCoverPageCheckBox = this.coverPageSelected === true
        this.disableAttchments = false
      }

      if (checkedIdArray.length === 0 && this.editedCheckedBoxes.length === 0) {
        this.formType = null
      } else if (!checkedIdArray) {
        this.disableCoverPageCheckBox = true
        for (let i = 1; i < this.scene.children.length; i++) {
          if (this.scene.children[i].type === 'container' && this.scene.children[i].name === 'Templates') {
            for (let j = 0; j < this.scene.children[i].children.length; j++) {
              if (checkedIdArray.indexOf(this.scene.children[i].children[j].id) >= 0) {
                let form = this.scene.children[i].children[j].data.form
                let templateId = this.templateOptions.filter(templateDoc => templateDoc.templates.includes(form.closest_template_id))
                if ((templateId[0] && this.formType !== templateId[0].value) || templateId[0] === undefined) {
                  this.formType = null
                }
              }
            }
          }
        }
      } else if (checkedIdArray.length >= 1) {
        this.documentAutoMatching(checkedIdArray)
      } else if (this.coverPageSelected === false) {
        this.disableCoverPageCheckBox = false
      }
    },
    addInsPages (data, key) {
      if (this.editInsCardsEnabled !== null) {
        this.selectedTitleDocs[key]['formIDs'] = this.selectedTitleDocs[key]['formIDs'].filter((id) => !this.selectedTitleDocs[key]['insurance_ids'].includes(id))
        this.selectedTitleDocs[key]['insurance_ids'] = []
        this.selectedTitleDocs[key]['insurance_pages'] = []
      }
      let scrollableContent = document.getElementsByClassName('scrollable-content')
      if (scrollableContent.length > 0) { scrollableContent[0].scrollTop = 0 }
      let checkedIdArray = []
      this.$refs.CheckboxClicks.map(element => {
        if (element.checked === true) {
          checkedIdArray.push(element.id)
        }
      })
      if (checkedIdArray.length > 0) {
        if (checkedIdArray.length > 1 || this.selectedTitleDocs[key]['insurance_pages'].length === 1) {
          this.$refs.multipleInsAlert.show()
          return
        } else {
          this.scene.children.map(column => {
            if (column.type === 'container') {
              column.children.map(element => {
                if (checkedIdArray.indexOf(element.id) >= 0) {
                  element.data.form.title = data.title
                  element.data.form.uuid = data.uuid
                  element.data.form.isInsurance = true
                  element.data.form.process = true
                  element.data.form.isEdited = false
                  this.selectedTitleDocs[key]['formIDs'].push(element.data.form.id)
                  this.selectedTitleDocs[key]['insurance_ids'].push(element.data.form.id)
                  this.selectedTitleDocs[key]['insurance_pages'].push(element.data.form.original_page_no)
                }
              })
            }
          })
        }
      }
      this.editInsCardsEnabled = null
      this.validAllForms()
      this.CheckboxClear()
      this.saveSelectedDocs()
    },
    addAttachments (patientDetails, title) {
      if (this.editAttachmentsEnabled !== null) {
        this.selectedTitleDocs[title]['formIDs'] = this.selectedTitleDocs[title]['formIDs'].filter((id) => !this.selectedTitleDocs[title]['attachment_formIds'].includes(id))
        this.selectedTitleDocs[title]['attachment_pages'] = []
        this.selectedTitleDocs[title]['attachment_formIds'] = []
      }
      let scrollableContent = document.getElementsByClassName('scrollable-content')
      if (scrollableContent.length > 0) { scrollableContent[0].scrollTop = 0 }
      let checkedIdArray = []
      this.$refs.CheckboxClicks.map(element => {
        if (element.checked === true) {
          checkedIdArray.push(element.id)
        }
      })
      if (checkedIdArray.length > 0) {
        this.scene.children.map(column => {
          if (column.type === 'container') {
            column.children.map(element => {
              if (checkedIdArray.indexOf(element.id) >= 0) {
                element.data.form.title = patientDetails.title
                element.data.form.uuid = patientDetails.uuid
                element.data.form.process = true
                element.data.form.isAttachment = true
                element.data.form.isEdited = false
                this.selectedTitleDocs[title]['attachment_pages'].push(element.data.form.original_page_no)
                this.selectedTitleDocs[title]['formIDs'].push(element.data.form.id)
                this.selectedTitleDocs[title]['attachment_formIds'].push(element.data.form.id)
              }
            })
          }
        })
      }
      this.editAttachmentsEnabled = null
      this.validAllForms()
      this.CheckboxClear()
      this.saveSelectedDocs()
    },
    editInsPages (data, key) {
      this.editInsCardsEnabled = key
      this.scene.children.map(column => {
        if (column.type === 'container') {
          column.children.map(element => {
            if (element.data.form && data.insurance_ids.includes(element.data.form.id)) {
              element.data.form.process = false
              element.data.form.isInsurance = false
              element.data.form.isEdited = true
              this.editedCheckedBoxes.push(element.data.form.id)
              Vue.nextTick(() => {
                this.checkmarkEditedAttachments(element.id)
              })
            }
          })
        }
      })
      this.saveSelectedDocs()
      this.sortEditedAttachedPages()
      this.CheckboxClear()
    },
    editAttachments (patientDetails, key) {
      this.editAttachmentsEnabled = key
      this.scene.children.map(column => {
        if (column.type === 'container') {
          column.children.map(element => {
            if (element.data.form && patientDetails.attachment_formIds.includes(element.data.form.id)) {
              element.data.form.process = false
              element.data.form.isAttachment = false
              element.data.form.isEdited = true
              this.editedCheckedBoxes.push(element.data.form.id)
              Vue.nextTick(() => {
                this.checkmarkEditedAttachments(element.id)
              })
            }
          })
        }
      })
      this.saveSelectedDocs()
      this.sortEditedAttachedPages()
      this.CheckboxClear()
    },
    checkmarkEditedAttachments (id) {
      this.$refs.CheckboxClicks.map(element => {
        if (element.id === id) {
          element.checked = true
        }
      })
    },
    sortEditedAttachedPages () {
      this.scene.children.map(column => {
        if ((column.type === 'container' && this.editAttachmentsEnabled) || (column.type === 'container' && this.editInsCardsEnabled)) {
          column.children.sort((a, b) => {
            if (a.data.form && b.data.form) {
              if (a.data.form.isEdited === true && b.data.form.isEdited === true) {
                return column.children.indexOf(a) - column.children.indexOf(b)
              }
              if (a.data.form.isEdited === false) return 1
              if (a.data.form.isEdited === true) return -1
              return column.children.indexOf(a) - column.children.indexOf(b)
            } else {
              return 0
            }
          })
        }
      })
    },
    removeAttachments (patientDetails, key) {
      if (key === this.editAttachmentsEnabled) {
        this.editAttachmentsEnabled = null
      }
      this.scene.children.map(column => {
        if (column.type === 'container') {
          column.children.map(element => {
            if (element.data.form && patientDetails.attachment_formIds.includes(element.data.form.id)) {
              element.data.form.process = false
              element.data.form.isAttachment = false
              element.data.form.isEdited = false
            }
          })
        }
      })
      this.selectedTitleDocs[key]['formIDs'] = this.selectedTitleDocs[key]['formIDs'].filter((id) => !this.selectedTitleDocs[key]['attachment_formIds'].includes(id))
      this.selectedTitleDocs[key]['attachment_pages'] = []
      this.selectedTitleDocs[key]['attachment_formIds'] = []
      this.vaildFormsData = false
      this.saveSelectedDocs()
      this.CheckboxClear()
    },
    removeInsPages (data, key) {
      if (key === this.editInsCardsEnabled) {
        this.editInsCardsEnabled = null
      }
      this.scene.children.map(column => {
        if (column.type === 'container') {
          column.children.map(element => {
            if (element.data.form && data.insurance_ids.includes(element.data.form.id)) {
              element.data.form.process = false
              element.data.form.isInsurance = false
              element.data.form.isEdited = false
            }
          })
        }
      })
      this.selectedTitleDocs[key]['formIDs'] = this.selectedTitleDocs[key]['formIDs'].filter((id) => !this.selectedTitleDocs[key]['insurance_ids'].includes(id))
      this.selectedTitleDocs[key]['insurance_pages'] = []
      this.selectedTitleDocs[key]['insurance_ids'] = []
      this.vaildFormsData = false
      this.saveSelectedDocs()
      this.CheckboxClear()
    },
    removePages (patientDetails, key) {
      this.scene.children.map(column => {
        if (column.type === 'container') {
          column.children.map(element => {
            if (element.data.form && patientDetails.formIDs.includes(element.data.form.id)) {
              element.data.form.process = false
              element.data.form.isEdited = false
            }
          })
        }
      })
      this.$delete(this.selectedTitleDocs, key)
      if (this.editAttachmentsEnabled === key) {
        this.editAttachmentsEnabled = null
      }
      this.validAllForms()
      this.CheckboxClear()
      this.saveSelectedDocs()
    },
    editPages (patientDetails, key) {
      this.editedCheckedBoxes = []
      this.isFirstEditButtonClicked = true
      this.scene.children.map(column => {
        if (column.type === 'container') {
          this.extractFormTypeData(column.name, column.children)
          column.children.map(element => {
            if (element.data.form && patientDetails.formIDs.includes(element.data.form.id) && !(patientDetails.attachment_formIds.includes(element.data.form.id)) && !(patientDetails.insurance_ids.includes(element.data.form.id))) {
              element.data.form.isEdited = true
              // TODO: PDX-285
              this.editedCheckedBoxes.push(element.data.form.id)
            } else if (element.data.form) {
              element.data.form.isEdited = false
            }
          })
        }
      })
      Object.keys(this.selectedTitleDocs).map(docTitle => {
        this.selectedTitleDocs[docTitle]['isEdited'] = false
      })
      this.selectedTitleDocs[key]['isEdited'] = true
      this.text = patientDetails['title']
      this.isEditedDoc = true
      this.disableSaveButton = false
      this.isEditedDocKey = key
      // this.selectedEditTitle = key
      this.formType = patientDetails['formType']
      this.isPatientIdSelected = Boolean(patientDetails['patient_id'])
      this.selectedForceTemplate = patientDetails['force_template_id']
      this.sortEditedForms()
    },
    sortEditedForms () {
      this.scene.children.map(column => {
        if (column.type === 'container' && this.isEditedDoc) {
          column.children.sort((a, b) => {
            if (a.data.form && b.data.form) {
              if (a.data.form.isEdited === true && b.data.form.isEdited === true) {
                return column.children.indexOf(a) - column.children.indexOf(b)
              }
              if (a.data.form.isEdited === false) return 1
              if (a.data.form.isEdited === true) return -1
              return column.children.indexOf(a) - column.children.indexOf(b)
            } else {
              return 0
            }
          })
        }
      })
    },
    validAllForms: function () {
      // validate the all forms in templates,IC and DL
      let validAllForms = true
      this.scene.children.map(column => {
        if (column.type === 'container' && ['Templates', 'Insurance cards', 'Drivers License', 'Unmatched Pages'].includes(column.name)) {
          column.children.map(element => {
            if (element.data.form) {
              if (element.data.form.process === false) {
                validAllForms = false
              }
            }
          })
        }
      })
      this.vaildFormsData = validAllForms
    },
    getResultCss: function (value) {
      return value['isEdited'] && this.isEditedDoc ? 'edit-result' : 'result'
    },
    clearEditedAttachedPages: function () {
      if (this.editAttachmentsEnabled || this.editInsCardsEnabled) {
        this.scene.children.map(column => {
          if (column.type === 'container') {
            column.children.map(element => {
              if (element.data.form && this.selectedTitleDocs[this.editAttachmentsEnabled] && this.selectedTitleDocs[this.editAttachmentsEnabled].attachment_formIds.includes(element.data.form.id)) {
                element.data.form.process = true
                element.data.form.isAttachment = true
                element.data.form.isEdited = false
              }
              if (element.data.form && this.selectedTitleDocs[this.editInsCardsEnabled] && this.selectedTitleDocs[this.editInsCardsEnabled].insurance_ids.includes(element.data.form.id)) {
                element.data.form.process = true
                element.data.form.isInsurance = true
                element.data.form.isEdited = false
              }
            })
          }
        })
        this.editAttachmentsEnabled = null
        this.editInsCardsEnabled = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-tooltip {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  margin-left: 2%;
  z-index: 1000;
  width: 375%; 
  height: 500%;
  display: inline-block;
}
.container-fluid {
  width: 500px
}
 .card-body, .card-block {
    padding: 1px;
  }
  .card {
    margin-bottom: 0px;
  }
  .scroll-image {
    height: 75vh; 
    overflow-y:auto
  }

  label {
    display: inline-block;
    padding-left: 5px;
    padding-right: 5px;
    margin-bottom: 0rem;
    text-transform: capitalize;
    font-weight: bold;
  }

  .result {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  padding: 5px;
}
.checkbox-padding {
  padding-left: 5px;
}

.notes-margin {
  margin-top: 20px;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  z-index: 9999; /* Ensure the loading overlay is above other content */
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-spinner {
  border: 6px solid #f3f3f3; /* Light grey */
  border-top: 6px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/forms/modifyProcessType.vue